<!-- <div class="preloader" [hidden]="load">
    <div class="loading">
        <img src="assets/images/loader/loader.svg" alt="">
    </div>
</div> -->

<app-loading [hidden]="load"></app-loading>

<section class="page-title page-title-layout3 text-center bg-overlay bg-parallax " style="
    background-size: cover; background-position: center center;">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <h1 class="pagetitle__heading mb-10">{{contactUs}}</h1>
                <nav>
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a routerLink="../home">{{home}}</a></li>
                        <li aria-current="page" class="breadcrumb-item active">{{contactUs}}</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</section>
<ngx-alerts></ngx-alerts>
<section class="contact-layout1 mt-30 mb-30">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="contact-panel__form">
                    <div class="row">
                        <!-- <div class="col-sm-12">
                            <h4 class="contact-panel__title">{{title_}}</h4>
                        </div> -->
                        <div class="col-sm-6 col-md-6 col-lg-6">
                            <!-- <div class="form-group">
                                <label for="contact-name">{{name_}} </label>
                                <input [(ngModel)]="name" autocomplete="off" type="text" class="form-control"
                                    placeholder="{{name_}}">
                            </div> -->


                                <div class="form-group">
                                    <label for="contact-website">{{title_}}</label>
                                    <input [(ngModel)]="title" autocomplete="off" type="text" class="form-control"
                                        placeholder="{{title_}}">
                                </div>
                            </div>

                        <div class="col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label for="contact-email">{{email_}} </label>
                                <input [(ngModel)]="email" autocomplete="off" type="email" class="form-control"
                                    placeholder="{{email_}}">
                            </div>
                        </div>
                        <!-- <div class="col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label for="contact-Phone">{{phone_}} </label>
                                <input autocomplete="off" [(ngModel)]="phone" type="text" class="form-control"
                                    placeholder="{{phone_}}">
                            </div>
                        </div>
                        -->
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <div class="form-group mb-20">
                                <label for="contact-message">{{message_}}</label>
                                <textarea [(ngModel)]="message" autocomplete="off" class="form-control"
                                    placeholder="{{message_}}"></textarea>
                            </div>
                            <button type="button" (click)="send()" class="btn btn__secondary btn__block ">Send Your
                                Message</button>
                            <div class="contact-result"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-sm-12 col-md-12 col-lg-5 offset-lg-1">
                <div class="contact-panel__info" style="background-color: #019cce;">

                    <div class="contact-block">
                        <h5 class="contact-block__title">Address</h5>
                        <ul class="contact-block__list list-unstyled">
                            <li>{{address_}}</li>
                        </ul>
                    </div>
                    <div class="contact-block">
                        <h5 class="contact-block__title">Email</h5>
                        <ul class="contact-block__list list-unstyled">
                            <li>{{email__}}</li>
                        </ul>
                    </div>
                    <div class="contact-block">
                        <h5 class="contact-block__title">Phone</h5>
                        <ul class="contact-block__list list-unstyled">
                            <li><a href="mailto:example@domain.com"></a>{{ph1}}</li>
                            <li><a href="mailto:example@domain.com"></a>{{ph1}}</li>
                        </ul>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</section>
